module.exports = __webpack_public_path__ + "static/mgmap-c176ce17c861c9d7fadad94148bf2f27.png";